import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { Train, Link2, FileText } from "lucide-react";
import { copyToClipboard } from "../../utils/copyToClipboard";

const UserProfile = ({ userJobRequestInfo, viewerType }) => {
  const handleCopyLink = () => {
    copyToClipboard();
  };

  if (!userJobRequestInfo) return null;

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        py: { xs: 2, md: 4 },
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: { xs: "center", md: "space-between" },
            alignItems: { xs: "center", md: "flex-start" },
            columnGap: 3,
            flexWrap: "wrap",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          {/* 左側：プロフィール情報 */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: { xs: "center" },
              alignItems: "center",
              gap: 4,
            }}
          >
            {/* イニシャル */}
            <Box sx={{ pr: { md: 2 } }}>
              <Typography variant="caption" color="text.secondary">
                イニシャル
              </Typography>
              <Typography
                variant="h3"
                fontWeight="extrabold"
                color="text.primary"
                sx={{ lineHeight: 1, whiteSpace: "nowrap" }}
              >
                {userJobRequestInfo.name}
              </Typography>
            </Box>

            {/* 詳細 */}
            <Box sx={{ pl: 2, color: "text.secondary", textAlign: "left" }}>
              <Typography variant="body2">
                エンジニア歴 {userJobRequestInfo.engineer_history}
              </Typography>
              <Typography variant="body2">
                {userJobRequestInfo.nationality} / {userJobRequestInfo.gender} /{" "}
                {userJobRequestInfo.age}歳
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: 1,
                  mt: 0.5,
                }}
              >
                <Train size={16} />
                <Typography variant="body2">
                  {userJobRequestInfo.nearest_station_line}{" "}
                  {userJobRequestInfo.nearest_station}
                </Typography>
              </Box>

              {/* メールアドレスの表示 */}
              {viewerType === "company" && userJobRequestInfo.email && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 1 }}
                >
                  {userJobRequestInfo.email}
                </Typography>
              )}
            </Box>
          </Box>

          {/* 右側：リンク関連 */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              gap: 1,
              px: 2,
            }}
          >
            <Box
              onClick={handleCopyLink}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                border: "1px solid #ccc",
                borderRadius: 1,
                px: 2,
                py: 0.5,
                bgcolor: "#fff",
                fontSize: "1rem",
                color: "primary.main",
                mt: { xs: 2, md: 0 },
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#f0f8ff",
                  borderColor: "primary.light",
                },
                gap: 1,
              }}
            >
              <Typography variant="body2">リンクコピー</Typography>
              <Link2 size={16} style={{ verticalAlign: "middle" }} />
            </Box>

            {/* スキルシート詳細 */}
            <Button
              href={
                viewerType === "company"
                  ? `/company/candidates/${userJobRequestInfo.id}/skill_sheet?from=job_request`
                  : "/skill_sheets"
              }
              size="small"
              endIcon={<FileText size={16} />}
              sx={{
                textTransform: "none",
                color: "primary.main",
                fontSize: "0.85rem",
                "&:hover": {
                  textDecoration: "underline",
                  color: "primary.dark",
                },
              }}
            >
              スキルシート詳細
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default UserProfile;
